module.exports = __webpack_public_path__ + "static/media/screen4.f3b2b742.png";